import { apiSlice } from "app/api/apiSlice"


export const healtStatusApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // HR
        getHealthStatus: builder.query({
            query: () => {
                return {
                    url: 'health/status',
                    method: 'GET'
                }
            }
        }),
        getCurrentUserHealthStatus: builder.query({
            query: () => {
                return {
                    url: 'health/status/my',
                    method: 'GET'
                }
            }
        })
    })
})

export const {
    useGetHealthStatusQuery,
    useLazyGetHealthStatusQuery,
    useLazyGetCurrentUserHealthStatusQuery,
} = healtStatusApiSlice